import React from "react";

function WorkIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFF">
      <path d="M480-277 277-480l203-203 203 203-203 203Zm43 176q-9 9-20 13.5T481-83q-11 0-22.5-4.5T438-101L101-438q-9-9-13.5-20T83-480q0-11 4.5-22.5T101-523l338-338q8-8 19-12.5t22-4.5q11 0 22 4.5t19 12.5l338 338q9 9 13.5 20.33Q877-491.33 877-480q0 11.25-4.7 22.5-4.69 11.25-13.3 19.5L523-101Zm-43-66 313-313-313-313-313 313 313 313Z"/>
    </svg>
  )

}

export default React.memo(WorkIcon);